import { EventCategory, EventName, useAnalytics } from './useAnalytics';
import {
  TAddToFavouritesPayload,
  TAddToFavouritesPayloadResponse,
  TRemoveFromFavouritesPayload,
  TRemoveFromFavouritesPayloadResponse,
} from './useFavourites';

export const useFavouritesAnalytics = () => {
  const { sendEvent, sendErrorEvent } = useAnalytics();

  const sendCreateListEvent = (
    e: TRemoveFromFavouritesPayload | TAddToFavouritesPayload | undefined,
    newListId: string,
  ) => {
    sendEvent({
      event_action: EventName.CREATE_LIST,
      event_category: EventCategory.ECOMMERCE,
      event_label: e?.source ?? '',
      custom: {
        list_id: newListId,
      },
      non_interaction: false,
    });
  };

  const sendAddToWishlistEvent = (e: TAddToFavouritesPayloadResponse, listId: string) => {
    sendEvent({
      event_action: EventName.ADD_TO_WISHLIST,
      event_category: EventCategory.ECOMMERCE,
      event_label: e.source,
      custom: {
        list_id: listId,
        item_number_event: e.productNumber,
        item_type_event: e.productType,
        product_quantity: e.quantity?.toString(),
      },
      non_interaction: false,
    });
  };

  const sendRemoveFromWishlistEvent = (e: TRemoveFromFavouritesPayloadResponse, listId: string) => {
    sendEvent({
      event_action: EventName.REMOVE_FROM_WISHLIST,
      event_category: EventCategory.ECOMMERCE,
      event_label: e.source,
      custom: {
        list_id: listId,
        item_number_event: e.productNumber,
        item_type_event: e.productType,
        product_quantity: e.quantity && `-${e.quantity}`,
      },
      non_interaction: false,
    });
  };

  return {
    sendErrorEvent,
    sendCreateListEvent,
    sendAddToWishlistEvent,
    sendRemoveFromWishlistEvent,
  };
};
